import { Text } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Pressable, Box } from 'native-base';
import React from 'react';

interface SelectableItemProps {
  onPress: () => void;
  label: string;
  isSelected: boolean;
  isDisabled?: boolean;
}

export const SelectableItem: React.FC<SelectableItemProps> = ({
  isSelected,
  label,
  onPress,
  isDisabled = false,
}) => (
  <Pressable onPress={onPress} isDisabled={isDisabled}>
    <Box
      px={Spacing['inline.nano']}
      py={Spacing['inline.quarck']}
      bg={isSelected ? 'brand.primary.principal' : 'neutral.white'}
      {...(isDisabled && { bg: 'neutral.white' })}
      borderRadius={'full'}
      borderWidth={0.3}
      borderColor={isDisabled ? 'neutral.medium' : 'neutral.dark'}>
      <Text
        variant="regular"
        lineHeight="medium"
        textAlign={'center'}
        textTransform={'uppercase'}
        color={isSelected ? 'neutral.white' : 'neutral.dark'}
        {...(isDisabled && { color: 'neutral.medium' })}>
        {label}
      </Text>
    </Box>
  </Pressable>
);
